import React, { useEffect, useState } from 'react';
import VariableRevenuesDetailPresentational from './VariableRevenuesDetailPresentational';
import { useDebouncedCallback } from 'use-debounce';
import {
  createBonus,
  getReportsVariableRevenues,
} from '../../../lib/fetch/reports';
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from 'use-query-params';
import { useLoading } from '../../../commons/Loading';
import { useAuth } from '../../../commons/Auth';
import { useTranslation } from 'react-i18next';
import { useAlert } from 'react-alert';

const VariableRevenuesDetail = (props) => {
  const { profile = {} } = props;

  const { REACT_APP_DEFAULT_PAGINATION_LIMIT = 50 } = process.env;
  const { _id: profileId } = profile;
  const { showLoading, hideLoading } = useLoading();
  const [{ newToken } = {}] = useAuth();
  const alert = useAlert();
  const [t] = useTranslation('CONTACTS');
  const [reports, setReports] = useState({
    categories: { gnet_admin: {}, supplier: {}, bonuses: { data: [] } },
    totals: {},
  });

  const [total, setTotal] = useState(0);

  const [query, setQuery] = useQueryParams({
    limit: withDefault(NumberParam, +REACT_APP_DEFAULT_PAGINATION_LIMIT),
    offset: NumberParam,
    year: withDefault(NumberParam, new Date().getFullYear()),
    accountabilityYear: NumberParam,
    accountabilityMonth: NumberParam,
    supplier: withDefault(StringParam, ''),
    number: withDefault(StringParam, ''),
    paid: withDefault(StringParam, ''),
  });

  const {
    limit,
    offset,
    search,
    supplier,
    number,
    year,
    accountabilityYear,
    accountabilityMonth,
    paid,
  } = query;

  const [fetchReportsRevenues] = useDebouncedCallback(async () => {
    showLoading();
    const response = await getReportsVariableRevenues({
      limit,
      offset,
      profileId,
      year,
      accountabilityYear,
      accountabilityMonth,
      newToken,
      supplier,
      number,
      paid,
    });

    hideLoading();

    if (response instanceof Error) {
      return alert.error(t('COMMON:GENERIC_ERROR'));
    }

    const { data = [] } = response;
    setReports(data);
    setTotal(data.categories?.variableRevenues?.count);
  }, 1000);

  useEffect(() => {
    fetchReportsRevenues();
  }, [
    limit,
    offset,
    year,
    accountabilityYear,
    accountabilityMonth,
    search,
    supplier,
    number,
    paid,
  ]);

  function onFilter(queryDiff) {
    if (
      (queryDiff.accountabilityYear &&
        queryDiff.accountabilityYear !== accountabilityYear) ||
      queryDiff.accountabilityYear === ''
    ) {
      queryDiff.accountabilityMonth = '';
    }

    if (
      (queryDiff.paid && queryDiff.paid !== paid) || // first search
      (paid && queryDiff.paid === '') ||
      (queryDiff.limit && queryDiff.limit !== limit)
    ) {
      queryDiff.offset = 0;
    }
    setQuery(queryDiff);
  }

  async function onAddBonus(bonus) {
    if (!(Number(bonus?.amount) > 0)) {
      alert.error(t('COMMON:ERROR_TOTAL_TO_INVOICE_0'));
      return;
    }

    const { error } = await createBonus({
      newToken,
      bonus: { ...bonus, profileId },
    });

    if (error) {
      alert.error(t('COMMON:GENERIC_ERROR'));
      return;
    }

    fetchReportsRevenues();
    alert.success(t('COMMON:SUCCESS_CREATE'));
  }

  return (
    <VariableRevenuesDetailPresentational
      {...props}
      data={reports}
      onAddBonus={onAddBonus}
      onFilter={onFilter}
      query={query}
      total={total}
      profileType={profile.type}
      profile={profile}
    />
  );
};

export default VariableRevenuesDetail;
